import React, { Component, Suspense } from "react";
import _, { set } from "lodash";
import Loader from "../../../Global/Loader";
import axios from "axios";
import { Icon } from "semantic-ui-react";
import { Tab } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { Button, Col, Card, CardBody, Row } from "reactstrap";
import TemplateForms from "../template";
import ContainerWrapper from "../../../template/Layout/ContentWrapper";
import SumaryDetail from "./components/general";
import { Services } from "../../../../repositories/clients/Services";
import Tooltip from "@mui/material/Tooltip";
import Swal from "sweetalert2";
import queryString from "query-string";
import { validateIdParams } from "../../../utils/regularExpressionValidation";
import "./styles/styles.scss";

import { FilterForRole } from "../../../Global/Permission/filter";
import { moduleActions } from "../../../Global/Permission/constants";
import createModal from "../../Components/ModalV2";
import { openNotification } from "../../Components/Notification";

const Comments = React.lazy(() => import("../../Components/Comments"));
const AllComments = React.lazy(() =>
  import("../../Components/Comments/AllComment")
);

const allowSatus = [1, 2];
class createUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalAlert: false,
      typeAlert: "",
      messageAlert: "",
      scrollLine: true,
      tabActive: 0,
      users: [],
      id: this.props.match.params.id,
      rolId: this.props._rolId,
      userId: this.props._user,
      data: {},
      TemplateForms,
      isEdit: false,
      createForms: [],
      generalInfo: "",
      idOrdenServicio: this.props.match ? this.props.match.params.id : -1,
      info: {},
      loadingInfo: true,
      isEditing: false,
      commentsData: [],
      AllcommentsData: [
        {
          id: 1,
          title: this.props.t("request"),
          data: [
            {
              expanded: false,
              id: "TP-SEA-2022-0025",
              message: [],
            },
            {
              expanded: false,
              id: "TP-SEA-2022-234",
              message: [
                // {
                //   Color: 1,
                //   Comment: "tester plan de transporte ",
                //   CommentId: 59,
                //   CreationDate: "31-08-2022 10:20:20 AM",
                //   Deleted: "0",
                //   DeletedDate: null,
                //   Important: "0",
                //   Module: "Shipment",
                //   ModuleId: 3,
                //   RolId: 1,
                //   Role: "Administrador",
                //   RowId: 336,
                //   User: "Info Info",
                //   UserId: 1,
                // }
              ],
            },
          ],
        },
        {
          id: 2,
          title: this.props.t("transport_plan"),
          data: [
            {
              expanded: false,
              id: "EP/COA/AI/S0025",
              message: [
                // {
                //   Color: 1,
                //   Comment: "tester plan de transporte ",
                //   CommentId: 59,
                //   CreationDate: "31-08-2022 10:20:20 AM",
                //   Deleted: "0",
                //   DeletedDate: null,
                //   Important: "0",
                //   Module: "Shipment",
                //   ModuleId: 3,
                //   RolId: 1,
                //   Role: "Administrador",
                //   RowId: 336,
                //   User: "Info Info",
                //   UserId: 1,
                // }
              ],
            },
          ],
        },
      ],
      catalogsData: [
        {
          ComTypeId: 1,
          ModuleId: 1,
          ComType: "Supplier Follow Up",
          value: 1,
          label: "Supplier Follow Up",
        },
        {
          ComTypeId: 2,
          ModuleId: 1,
          ComType: "Order Quality",
          value: 2,
          label: "Order Quality",
        },
        {
          ComTypeId: 3,
          ModuleId: 1,
          ComType: "Order Quantities",
          value: 3,
          label: "Order Quantities",
        },
        {
          ComTypeId: 10,
          ModuleId: 1,
          ComType: "Other",
          value: 10,
          label: "Other",
        },
      ],
      catalgoSearch: [],
      posList: [],
      posPO: [],
    };
  }

  componentDidMount = async () => {
    const isNotify = queryString.parse(this.props.location.search);
    let notifyActiveComment = false;

    if (isNotify.nofify) {
      notifyActiveComment = true;
    }
    this.getInfoTp(notifyActiveComment);
    this.getCommets(false);
  };
  componentWillReceiveProps = (nextProps) => {
    const isNotify = queryString.parse(nextProps.location.search);
    let notifyActiveComment = false;

    const newProp = nextProps.match.params.id
      ? nextProps.match.params.id
      : this.props.match.params.id;

    this.setState(
      {
        newSelected: [],
        selectcheck: false,
        Form: nextProps.form,
        reset: true,
      },
      () => {
        if (isNotify.nofify) {
          notifyActiveComment = true;
          this.setState(
            {
              idOrdenServicio: newProp,
              loadingInfo: true,
            },
            () => {
              this.getInfoTp(notifyActiveComment);
              this.getCommets(true);
            }
          );
        }
      }
    );
  };

  getInfoTp = async (notifyActiveComment) => {
    let { idOrdenServicio, userId } = this.state;
    let idValidate = validateIdParams(idOrdenServicio);
    if (!idValidate) {
      openNotification('error', this.props.t("Data_entered_is_invalid"));
      setTimeout(() => {
        this.props.history.push("/transport-plans");
      }, 2000);
      return;
    }
    await axios
      .get(
        `${Services.PLANTRANSPORT.path
        }plantrasp/info-tp/${idOrdenServicio}?user=${Number(userId)}&lang=${this.props.lng
        }`,
        {}
      )
      .then((response) => {
        if (!response.data.data.info) {
          openNotification('error', this.props.t("Data_entered_is_invalid"));
          setTimeout(() => {
            this.props.history.push("/transport-plans");
          }, 2000);
        } else {
          let info = response.data.data;
          let users = response.data.data.Users;

          this.setState(
            {
              tabActive: notifyActiveComment ? 1 : 0,
              info,
              users,
            },
            () => {
              this.getCatalogs(info);
            }
          );
        }
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  sortCatalogs = (array, attr) => {
    try {
      array.sort((a, b) => {
        const valueA = a[attr];
        const valueB = b[attr];
        if (valueA === undefined || valueB === undefined) {
          return 0;
        }
        return valueA.localeCompare(valueB);
      });

      return array;
    } catch (e) {
      console.log(e);
      return array;
    }
  };
  getCatalogs = async (info) => {
    let userId = this.props._user;
    await axios
      .get(`${Services.PLANTRANSPORT.path}plantrasp/catalogs/${userId}`, {})
      .then((response) => {
        let catalgoSearch = [];
        let data = response.data.data;
        let keys = Object.keys(data);
        keys.forEach((key) => {
          if (data[key] && data[key].length > 0) {
            this.sortCatalogs(data[key], "text");
          }
        });

        catalgoSearch.push(data);
        if (info.info) {
          this.setState(
            {
              catalgoSearch,
              loadingInfo: false,
            },
            () => {
              this.getOrdersTo(info.info.CustomerId, info.info.CustomerCode);
            }
          );
        } else {
          this.setState({
            catalgoSearch,
            loadingInfo: false,
          });
        }
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  resendtp = async (id) => {
    this.setState({
      loadingInfo: true,
    });

    await axios
      .get(`${Services.PLANTRANSPORT.path}plantrasp/resendtp${id}`)
      .then((response) => {
        this.setState(
          {
            loadingInfo: false,
            modalAlert: true
          },
          () => {

            if (response.data.status == 500) {
              this.setState({ typeAlert: "error", messageAlert: this.props.t("error_send_tp") })
              this.getInfoTp();
            } else {
              this.setState({ typeAlert: "success", messageAlert: this.props.t("pt_send_success") })
            }

            this.getInfoTp();
          }
        );
      })
      .catch((error) => {
        console.warn(error);
        this.setState({
          loadingInfo: false,
        });
      });
  };

  getOrdersTo = async (IdCustomer, codeEP) => {
    let { catalgoSearch } = this.state;
    let lang = this.props.lng;

    let data = {
      IdCustomer: IdCustomer,
      codeEP: codeEP,
      lang,
    };

    await axios
      .post(`${Services.PLANTRANSPORT.path}plantrasp/getorder-to`, data)
      .then((response) => {
        let posList = response.data.data;
        let posPO = response.data.dataPo;
        let catAgente = response.data.catAgente;
        catalgoSearch[0].CatAgente = catAgente;

        for (let i = 0; i < posList.length; i++) {
          const e = posList[i];
          e.hidden = false;
          e.Visible = 1;
          e.checked = false;
        }
        for (let i = 0; i < posPO.length; i++) {
          const e = posPO[i];
          e.hidden = false;
          e.key = e.POItemsId;
          e.Visible = 1;
          e.checked = false;
        }
        // console.log("posPO", posPO);
        this.setState({
          posList,
          catalgoSearch,
          posPO,
        });
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  cancelar = () => {
    let { isEdit } = this.state;
    this.setState({ isEdit: !isEdit });
  };

  tabChange = (a, b, c) => {
    this.setState({ isEdit: false });
  };

  updateInfoPt = async (info, status) => {
    this.setState({ loadingInfo: true });
    info.UserUpdateId = this.props._user;
    await axios
      .put(`${Services.PLANTRANSPORT.path}plantrasp/updatetp`, info)
      .then((response) => {

        this.setState({
          modalAlert: true, typeAlert: "success", messageAlert: status === 2
            ? response.data.errorAsociacion
              ? this.props.t("asociation_message_error_update") + "!"
              : this.props.t("update_transport_plan") + "!"
            : this.props.t("draft_updated_success")
        })
        this.setState({ loadingInfo: false, isEdit: false }, () => {
          this.getInfoTp();
        });
      })
      .catch((error) => {
        this.setState({ loadingInfo: false, isEdit: false }, () => {
          this.setState({
            modalAlert: true, typeAlert: "error", messageAlert: this.props.t("pt_send_error")
          })
        });

        console.warn(error);
      });
  };

  getCommets = async (noscroll, messageSucces) => {
    const { idOrdenServicio } = this.state;
    let moduleId = 1;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let idValidate = await validateIdParams(idOrdenServicio);
    // let idContainer = 1816;
    if (idValidate) {
      axios
        .get(
          `${Services.PLANTRANSPORT.path}comment-plantrasp/get-comment?rowid=${idOrdenServicio}&moduleid=${moduleId}&general=true&zona=${timezone}&lang=${this.props.lng}`
        )
        .then((response) => {
          let comentario = response.data.Comment;
          let AllcommentsData = response.data.CommentGeneral;
          this.setState(
            { commentsData: comentario, AllcommentsData, scrollLine: noscroll },
            () => {
              if (messageSucces) {
                openNotification('success', messageSucces);
              }
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  newMessage = async (data) => {
    let { idOrdenServicio, userId } = this.state;
    data.Rowid = idOrdenServicio;
    data.UserId = userId;
    data.ModuleId = 1;

    if (data.Mentions.length > 0) {
      let uniq = [...new Set(data.Mentions)];
      data.Mentions = uniq;
    }

    axios
      .post(`${Services.PLANTRANSPORT.path}comment-plantrasp/add-comment`, data)
      .then((response) => {
        this.getCommets(false, this.props.t("comment_successfully_saved"));
      })
      .catch((error) => {
        console.log(error);
        openNotification('error', this.props.t("comment_send_error"));
      });
  };

  deleteMessage = async (idDelete, toggle) => {
    axios
      .delete(
        `${Services.PLANTRANSPORT.path}comment-plantrasp/delete-comment/${idDelete}`
      )
      .then((response) => {
        this.getCommets(false, this.props.t("comment_successfully_deleted"));
        toggle()
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    let {
      tabActive,
      loadingInfo,
      TemplateForms,
      catalgoSearch,
      posList,
      info,
      isEdit,
      users,
      rolId,
      userId,
      AllcommentsData,
      commentsData,
      posPO,
      modalAlert,
      typeAlert,
      messageAlert
    } = this.state;
    return loadingInfo ? (
      <Loader />
    ) : (
      <ContainerWrapper>
        <div className="content-heading">
          <span className="icon-transport-plans icon-header" />
          {this.props.t("transports_plans")}
          <div className="euro-return-tittle">
            <Icon.Group size="large">
              <Icon
                name="angle left"
                className="_btnBack"
                size="big"
                onClick={() => this.props.history.push("/transport-plans")}
              />
            </Icon.Group>
            <span className="label-back" onClick={() => this.props.history.push("/transport-plans")}>
              {this.props.t("back")}
            </span>
          </div>
        </div>
        <>
          <Tab
            loading={true}
            menu={{ secondary: true, pointing: true, className: 'custom-tab-menu' }}
            onTabChange={(event, data) =>
              this.setState(
                { tabActive: data.activeIndex },
                () => this.tabChange
              )
            }
            activeIndex={tabActive}
            panes={[
              {
                menuItem: this.props.t("summary"),
                render: () => (
                  <div className="row">
                    <div className="col-6"></div>
                    <div className="col-6" style={{ marginTop: "-60px" }}>
                      <div
                        hidden={
                          info.info && allowSatus.includes(info.info.StatusId)
                            ? !isEdit
                              ? false
                              : true
                            : true
                        }
                        style={{ paddingRight: "15px" }}
                        className="row"
                      >
                        <FilterForRole
                          rol={this.props._rolId}
                          userId={this.props._user}
                          moduleAction={moduleActions.PLAN_TRANSPORTE_EDITAR}
                          userCreatedId={
                            info.info ? info.info.UserCreateId : ""
                          }
                        >
                          <div
                            className={`${info.info && info.info.StatusId === 2
                              ? "col-7 col-sm-7 col-lg-7 col-md-7"
                              : "col-lg-12"
                              } `}
                          >
                            <Button
                              color="primary"
                              className="float-right custom-width-btn"
                              onClick={() => this.setState({ isEdit: true })}
                            >
                              {this.props.t("edit")}
                            </Button>
                          </div>
                        </FilterForRole>
                        {info.info && info.info.StatusId === 2 ? (
                          <FilterForRole
                            rol={this.props._rolId}
                            userId={this.props._user}
                            moduleAction={moduleActions.PLAN_TRANSPORTE_EDITAR}
                            userCreatedId={
                              info.info ? info.info.UserCreateId : ""
                            }
                          >
                            <div className="col-5 col-sm-5 col-lg-5 col-md-5">
                              <Button
                                // variant="contained"
                                color="primary"
                                // style={{ width: "auto" }}
                                className="float-right"
                                onClick={() => {
                                  let { TypeOrder } = info.info;
                                  if (TypeOrder === 2) {
                                    const objetosNoValidos = info.opList.filter(
                                      (objeto) => {
                                        return (
                                          !objeto ||
                                          objeto.EuroSupplerId === null ||
                                          objeto.EuroSupplerId === "" ||
                                          objeto.EuroConsigneeId === null ||
                                          objeto.EuroConsigneeId === ""
                                        );
                                      }
                                    );
                                    if (objetosNoValidos.length === 0) {
                                      this.resendtp(info.info.TransportPlanId);
                                    } else {
                                      Swal.fire({
                                        text: `${this.props.t(
                                          "asociation_message_error_resend"
                                        ) + "!"
                                          }`,
                                        icon: "error",
                                        confirmButtonColor: "#0561fc",
                                        confirmButtonText: "Ok",
                                        customClass: {
                                          confirmButton: 'custom-width-btn swal'
                                        }
                                      });
                                    }
                                  } else {
                                    this.resendtp(info.info.TransportPlanId);
                                  }
                                }}
                              >
                                {this.props.t("buttom_resend_tp")}
                              </Button>
                            </div>
                          </FilterForRole>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <ContainerWrapper>
                      <Card className="myCard">
                        <CardBody>
                          <Col md={12} xl={12}>
                            <Row>
                              <Col
                                className="d-flex align-items-center"
                                md={3}
                                lg={3}
                                sm={12}
                              >
                                <span className="custom-number-header">
                                  {/* Plan de transporte No.&nbsp; */}
                                  <React.Fragment>
                                    {info.info ? info.info.TransportPlanNo : ""}
                                  </React.Fragment>
                                </span>
                              </Col>
                              {/* // !if -- data.ParentPOId ?  */}
                              <Col md={3} lg={2} sm={12}>
                                <span class="badge badge-euro">
                                  {" "}
                                  {info.info ? info.info.Status : ""}
                                </span>
                              </Col>
                              <Col className=" d-flex align-items-center justify-content-end">
                                <div
                                  style={{ marginLeft: "1em" }}
                                  className="date_content"
                                >
                                  <h5
                                    style={{ fontSize: "12px" }}
                                    className="date_header"
                                  >
                                    <em
                                      style={{
                                        fontWeight: "bold",
                                      }}
                                      className="label_title"
                                    >
                                      {this.props.t("update_date")}:
                                    </em>
                                    <em
                                      style={{
                                        fontSize: "12px",
                                      }}
                                      className="label_title"
                                    >
                                      {" "}
                                      {info.info
                                        ? info.info.UpdateDate
                                        : ""}{" "}
                                    </em>
                                  </h5>
                                </div>
                                <div
                                  style={{ marginLeft: "1em" }}
                                  className="date_content"
                                >
                                  <h5
                                    style={{ fontSize: "12px" }}
                                    className="date_header"
                                  >
                                    <em
                                      style={{
                                        fontWeight: "bold",
                                      }}
                                      className="label_title"
                                    >
                                      {this.props.t("user_colon")}
                                    </em>{" "}
                                    <em
                                      style={{
                                        fontSize: "12px",
                                      }}
                                      className="label_title"
                                    >
                                      {" "}
                                      {info.info
                                        ? info.info.UserUpdateName
                                        : ""}{" "}
                                    </em>
                                  </h5>
                                </div>

                                <Tooltip
                                  style={{ marginLeft: "-9px" }}
                                  title={
                                    <div>
                                      <div
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          marginLeft: "1em",
                                        }}
                                        className=""
                                      >
                                        {/* <h5 className="date_header label-euro"> */}
                                        <em className="label-euro">
                                          {this.props.t("create_date")}
                                        </em>
                                        {/* </h5> */}
                                        <h5 className="date_header label-euro">
                                          <em
                                            className="date_header label-euro "
                                            style={{ marginLeft: "5px" }}
                                          >
                                            {info.info
                                              ? info.info.CreationDate
                                              : ""}{" "}
                                          </em>
                                        </h5>
                                      </div>
                                      <div
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          marginLeft: "1em",
                                        }}
                                        className=""
                                      >
                                        {/* <h5 className="date_header label-euro"> */}
                                        <em className="label-euro">
                                          {this.props.t("user_colon")}
                                        </em>
                                        {/* </h5> */}
                                        <h5 className="date_header label-euro">
                                          <em
                                            className="date_header label-euro "
                                            style={{ marginLeft: "5px" }}
                                          >
                                            {info.info
                                              ? info.info.UserCreateName
                                              : ""}{" "}
                                          </em>
                                        </h5>
                                      </div>
                                    </div>
                                  }
                                  placement="right"
                                >
                                  {/* <em className="icon-final-25 mr-3 euro-info-icon"></em> */}
                                  <span className="icon-informative-tooltip custom-icon-tooltip yellow" />

                                </Tooltip>
                              </Col>
                            </Row>
                          </Col>
                        </CardBody>
                      </Card>
                      <SumaryDetail
                        TemplateForms={TemplateForms}
                        catalgoSearch={catalgoSearch}
                        isView={true}
                        posList={posList}
                        info={info}
                        posPO={posPO}
                        isEdit={isEdit}
                        cancelar={this.cancelar}
                        updateInfoPt={this.updateInfoPt}
                      ></SumaryDetail>
                    </ContainerWrapper>
                  </div>
                ),
              },
              {
                menuItem: this.props.t("comments"),
                render: () => (
                  // <div>
                  <Suspense fallback={<div>Loading...</div>}>
                    <ContainerWrapper>
                      <div class="row">
                        <div class="col-xs-12 col-md-6 col-lg-6">
                          <legend className="legendEuroBold">
                            {info.info ? info.info.TransportPlanNo : ""}
                          </legend>
                          <Comments
                            scrollLine={this.state.scrollLine}
                            rolId={rolId}
                            userId={userId}
                            data={commentsData}
                            catalogs={users}
                            funtionNewMessage={this.newMessage}
                            funtionDeleteMessage={this.deleteMessage}
                          />
                        </div>
                        <div class="col-xs-12 col-md-6 col-lg-6">
                          <legend className="legendEuroBold">
                            {this.props.t("related_comments")}
                          </legend>

                          <AllComments data={AllcommentsData} />
                        </div>
                      </div>
                    </ContainerWrapper>
                  </Suspense>

                  // </div>
                ),
              },
              // { menuItem: 'Comments', render: () => <Suspense fallback={<div>Loading...</div>}><ConsolComment _rolId={this.props._rolId} order={order} idCustomer={idCustomer} userId={userId} ></ConsolComment></Suspense> },
              // { menuItem: 'Change Logs', render: () => <Suspense fallback={<div>Loading...</div>}><ConsolRevisionLogs changeLog2={changeLog2} changeLog={changeLog}></ConsolRevisionLogs></Suspense>}
            ]}
          />
        </>
        {createModal({
          isModalOpen: modalAlert,
          titleModal: typeAlert !== 'error' ? 'Success' : 'Error',
          type: typeAlert,
          component: (
            <>
              <div className="col-12" style={{ textAlign: "center" }}>
                <p>{messageAlert}</p>
              </div>
            </>
          ),
          buttons: [
            {
              text: this.props.t("Ok"),
              onClick: () => this.setState({ modalAlert: false }),
              type: "primary",
            }
          ],
          onCancel: () => this.setState({ modalAlert: false })
        })}
      </ContainerWrapper>
    );
  }
}

export default withNamespaces()(withRouter(createUsers));
